import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, Star } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Dejar de vivir al día y romper el ciclo de escasez', 'Entender por fin en qué se va tu dinero (sin juzgarte)', 'Crear un presupuesto realista que SÍ funciona para ti', 'Empezar a ahorrar, aunque hoy sientas que no te sobra nada', 'Salir de deudas sin sentirte ahogada ni restringida', 'Construir hábitos financieros que te acompañen todo el 2026'];
  return <section className="py-20 md:py-28 bg-gradient-to-b from-cream-100 to-peach-50 px-4 overflow-hidden" data-id="element-139">
      <div className="max-w-6xl mx-auto" data-id="element-140">
        <div className="flex flex-col md:flex-row items-center gap-16 md:gap-24" data-id="element-141">
          {/* Left side: Image/Graphic representation */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2 relative" data-id="element-142">
            {/* Organic blob background behind book */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-peach-200/30 rounded-[60%_40%_30%_70%/60%_30%_70%_40%] blur-2xl -z-10 animate-pulse" style={{
            animationDuration: '10s'
          }} data-id="element-143"></div>

            <div className="relative aspect-[4/5] md:aspect-square bg-white rounded-[2.5rem] shadow-warm-xl overflow-hidden border-8 border-white transform rotate-2 hover:rotate-0 transition-transform duration-700 ease-out" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/pdYhiUJ3qquC341iqFWNnc/Gemini_Generated_Image_vmz4invmz4invmz4.png" alt="Transforma tus Finanzas en 30 días - Libro" className="absolute inset-0 w-full h-full object-cover" data-id="element-145" />
            </div>

            {/* Floating testimonial card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5
          }} className="absolute -bottom-10 -right-4 md:-right-10 bg-white p-4 rounded-2xl shadow-warm-lg border border-peach-100 max-w-[200px]" data-id="element-146">
              <div className="flex gap-1 mb-2" data-id="element-147">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 text-yellow-400 fill-current" data-id="element-148" />)}
              </div>
              <p className="text-xs text-gray-600 font-medium" data-id="element-149">
                "¡Por fin entiendo mis finanzas! Gracias."
              </p>
            </motion.div>
          </motion.div>

          {/* Right side: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2" data-id="element-150">
            <h2 className="text-3xl md:text-5xl font-bold text-warm-gray mb-8 leading-tight" data-id="element-151">
              📘 El eBook que te dará claridad en{' '}
              <span className="relative inline-block text-coral-600" data-id="element-152">
                SOLO 30 días
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-peach-300" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-153">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="none" data-id="element-154" />
                </svg>
              </span>
            </h2>

            <p className="text-xl text-warm-800 mb-10 leading-relaxed" data-id="element-155">
              No teoría aburrida. No complicaciones matemáticas. Un camino
              claro, paso a paso, con ejemplos reales diseñados para mujeres
              como tú.
            </p>

            <ul className="space-y-5" data-id="element-156">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start group" data-id="element-157">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-peach-100 flex items-center justify-center mt-0.5 mr-4 group-hover:bg-coral-100 transition-colors" data-id="element-158">
                    <Check className="w-5 h-5 text-terracotta-600" data-id="element-159" />
                  </div>
                  <span className="text-warm-800 text-lg" data-id="element-160">{benefit}</span>
                </motion.li>)}
            </ul>

            <div className="mt-12 p-6 bg-white rounded-2xl border-l-4 border-coral-500 shadow-warm-sm" data-id="element-161">
              <p className="text-warm-800 font-medium text-lg italic" data-id="element-162">
                "Este no es otro libro de finanzas. Es tu plan de acción para
                recuperar tu paz mental."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}